// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MediumCircleFilledSvg from "@fishx/icons-svg/es/asn/MediumCircleFilled";
import FishxIcon from '../components/FishxIcon';

var MediumCircleFilled = function MediumCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MediumCircleFilledSvg
  }));
};

MediumCircleFilled.displayName = 'MediumCircleFilled';
export default React.forwardRef(MediumCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MediumCircleFilled.js
// module id = 3104
// module chunks = 0